import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectProject
} from "~/components/Forms";

function RequestDemoFormAdd({onHandleSubmit})
{
	const initialValues = {
		projectId: 0,
		url: '',
	}

	const validationSchema = Yup.object().shape({
		projectId: Yup.string().required('Bạn chưa chọn dự án'),
		url: Yup.string().required('Bạn chưa nhập link hình ảnh demo')
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) =>
	{
		await onHandleSubmit(data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="projectId" render={({ field }) => (
				<SelectProject label="Dự án" options={[]} errors={errors} {...field} />
			)}/>
			<Controller control={control} name="url" render={({field}) => (
				<InputField label="Link hình ảnh demo" errors={errors} {...field} />
			)}/>
			<hr/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Thêm yêu cầu</Button>
			</div>
		</form>
	)
}

export default RequestDemoFormAdd;